<div
  class="items-container"
  [style.maxWidth]="width"
  [style.--scroll-item-width]="itemWidth + 'px'"
>
  <div class="selectedFrame">
    <span></span>
  </div>
  <div class="items snap-inline hide-scroll" #items>
    <ng-content select="[items]"></ng-content>
  </div>
</div>
